import React from "react";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import getNotifiche from "../../services/getNotifiche";
import getStudenti from "../../services/getStudenti";
import setNotificheRead from "../../services/setNotificheRead";
import moment from "moment";

// Assicurati che il nome del file e l'export corrispondano
import { NotificationsContext } from "../../context/NotificationContext";

class Notifiche extends React.Component {
  // Consente di accedere al contesto tramite this.context
  static contextType = NotificationsContext;

  constructor(props) {
    super(props);
    this.state = {
      notifiche: [],
      studenti: [],
      isLoading: false,
      waitDialogVisible: false,
    };
  }

  async reload() {
    const { updateNotificheCount } = this.context;
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const userId = cookies.get("userId", { path: "/" });

    const notifiche = await getNotifiche(username, token, userId);
    const studenti = await getStudenti(username, token);

    const notificheAggiornate = notifiche.map((n) => {
      const studente = studenti.find((s) => s.id === n.sent_by);
      // Formattazione data nel formato gg/mm/aaaa
      const formattedDate = moment(n.created_at).format("DD/MM/YYYY HH:mm");
      return {
        ...n,
        created_at: formattedDate,
        _name: studente
          ? `${studente.nome} ${studente.cognome}`
          : "Sconosciuto",
      };
    });

    this.setState({ notifiche: notificheAggiornate, studenti });

    const unreadCount = notificheAggiornate.reduce(
      (acc, n) => (n.read === 0 ? acc + 1 : acc),
      0
    );
    updateNotificheCount(unreadCount);
  }

  async componentDidMount() {
    await this.reload();
  }

  async markAllAsRead() {
    if (!window.confirm("Vuoi segnare tutte le notifiche come lette?")) return;

    this.setState({ isLoading: true });

    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    // Filtro delle notifiche non lette
    const unreadNotifications = this.state.notifiche.filter(
      (n) => n.read === 0
    );

    // Segnare ciascuna notifica come letta
    for (const notification of unreadNotifications) {
      await setNotificheRead(username, token, notification.id);
    }

    // Impostare il contatore delle notifiche a zero
    this.context.updateNotificheCount(0);

    this.setState({ isLoading: false });

    // Ricaricare le notifiche
    await this.reload();
  }

  render() {
    const headCells = [
      { id: "created_at", numeric: false, disablePadding: true, label: "Data" },
      { id: "title", numeric: false, disablePadding: true, label: "Titolo" },
      { id: "body", numeric: false, disablePadding: true, label: "Testo" },
      {
        id: "_name",
        numeric: false,
        disablePadding: true,
        label: "Nome studente",
      },
    ];

    const searchCols = ["created_at", "title", "_name", "body"];

    if (!this.state.notifiche) return <div />;

    return (
      <LoadingOverlay
        active={this.state.isLoading}
        spinner
        text={"Loading your content..."}
      >
        <h1>Notifiche</h1>
        {this.state.notifiche.length > 0 &&
          this.state.notifiche.some((n) => n.read === 0) && (
            <div style={{ marginBottom: "20px" }}>
              <button
                onClick={() => this.markAllAsRead()}
                style={{
                  padding: "8px 15px",
                  backgroundColor: "#A00008",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Segna tutte come lette
              </button>
            </div>
          )}
        <Table
          headCells={headCells}
          searchCols={searchCols}
          excel={false}
          calendar={false}
          mail={false}
          desc={true}
          pdf={false}
          rows={this.state.notifiche}
          orderBy="created_at"
          defaultOrder="desc"
          onEventClick={async (id) => {
            const message = "Vuoi segnare la notifica come letta?";
            if (window.confirm(message) === false) return;

            const cookies = new Cookies();
            const username = cookies.get("username", { path: "/" });
            const token = cookies.get("token", { path: "/" });

            this.context.updateNotificheCount((prev) =>
              prev > 0 ? prev - 1 : 0
            );

            await setNotificheRead(username, token, id);
            await this.reload();
          }}
        />
        <WaitDialog show={this.state.waitDialogVisible} />
      </LoadingOverlay>
    );
  }
}

export default Notifiche;
